import React from 'react';
import WidgetDSAInterface from 'modules/shared/widgets/interfaces/widgets-data/widget-dsa.interface';
import WidgetDSA from 'modules/shared/widgets/components/widget-dsa';

import './widget-dsa-badge.scss';

interface WidgetDSABadgeProps {
    dsa: WidgetDSAInterface;
}

const WidgetDSABadge: React.FC<WidgetDSABadgeProps> = ({ dsa }) => {
    return (
        <div className="widget-dsa-badge">
            <span>Reklama</span>
            <WidgetDSA
                size={12}
                dsa={dsa}
                color="gray"
            />
        </div>
    );
};

export default WidgetDSABadge;
